var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{ref:"articleHeaderButton",staticClass:"d-flex align-center justify-center my-2 my-sm-3",class:_vm.newArticleDetailsDisplay
      ? 'article-header-button-redesign mr-sm-4 px-3'
      : 'article-header-button mr-sm-6 py-3 px-6',attrs:{"outlined":_vm.outlined,"aria-label":_vm.ariaLabel,"color":_vm.color,"elevation":"0"},on:{"click":_vm.onClick}},[_vm._t("default"),_vm._v(" "),_c('span',{class:_vm.newArticleDetailsDisplay
        ? 'article-header-button-redesign__text'
        : 'article-header-button__text'},[_vm._v("\n    "+_vm._s(_vm.buttonText))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }